import { SSURGO } from 'constants/features';

export const isSsurgoEnabled = (productFeatures, fieldUuid) => {
  return productFeatures.byUuid[fieldUuid].SoilMap;
};

export const filterManagementZonesByFeatures = (managementZones, productFeatures) => {
  const fieldUuid = Object.keys(productFeatures.byUuid)[0];

  // If SSURGO is enabled for a country, then all fields will have that feature enabled.
  // So its enough to check for one field.
  if(isSsurgoEnabled(productFeatures, fieldUuid)) {
    return managementZones;
  }
  
  return managementZones.filter(zone => zone.id !== SSURGO);
};

